import { fromJS } from 'immutable'

import * as actionTypes from './actionTypes'

const defaultState = fromJS({
    datetime_category_list: [
        { label: '所有', value: 'all', active: true, },
        { label: '今天', value: 'today', active: false },
        { label: '过去3天', value: 'third_day', active: false },
        { label: '过去7天', value: 'seventh_day', active: false },
        { label: '过去30天', value: 'thirtieth_day', active: false },
    ],
    content_category_list: [
        { label: '对话', value: 'conversation', active: true, },
        { label: '聊天内容', value: 'ask', active: false },
    ],
    collection_conversation_list: [],
    collection_message_list: [],
    mall_components_list: [
        // {
        //     name: '基础功能',
        //     overview: '基础模型擅长为你的疑问，提供最基本的信息。，提供最基本的信息。',
        //     description: '基础模型擅长为你的疑问，提供最基本的信息。，提供最基本的信息。',
        //     avatar_tb: '',
        //     category: "业务模型",
        //     avatar: '',
        //     id: 11,
        //     desc: '基础功能 desc',
        //     permissions: ["read", "write", "execute", "delete"],     // execute 代表已购买
        //     is_limit_time_free: true,
        //     has_select: true,
        //     has_add: 0,
        // },
        // {
        //     name: '联网功能',
        //     overview: '联网印记可以让你的原石随时接入互联网搜索答案。',
        //     description: '联网印记可以让你的原石随时接入互联网搜索答案。',
        //     avatar_tb: '',
        //     category: "辅助模型",
        //     avatar: '',
        //     id: 12,
        //     desc: '联网功能 desc',
        //     permissions: ["read", "write", "execute", "delete"],
        //     is_limit_time_free: true,
        //     has_select: false,
        //     has_add: 0,
        // },
        // {
        //     name: '知识库',
        //     overview: '联网印记可以让你的原石随时接入互联网搜索答案。联网印记可以让你的原石随时接入互联网搜索答案。',
        //     description: '联网印记可以让你的原石随时接入互联网搜索答案。',
        //     avatar_tb: '',
        //     category: "学科模型",
        //     avatar: '',
        //     id: 13,
        //     desc: 'desc',
        //     permissions: ["read", "write", "execute", "delete"],
        //     is_limit_time_free: true,
        //     has_select: false,
        //     has_add: 0,
        // },
    ],
})

const reducer = (state=defaultState, action) => {
    switch(action.type) {
        case actionTypes.DATETIME_CATEGORY_LIST_ACTION:
            return state.merge({
                'datetime_category_list': fromJS(action.data),
            })
        case actionTypes.CONTENT_CATEGORY_LIST_ACTION:
            return state.merge({
                'content_category_list': fromJS(action.data),
            })
        case actionTypes.COLLECTION_CONVERSATION_LIST:
            return state.merge({
                'collection_conversation_list': fromJS(action.data),
            })
        case actionTypes.COLLECTION_MESSAGE_LIST:
            return state.merge({
                'collection_message_list': fromJS(action.data),
            })
        case actionTypes.SET_MALL_COMPONENTS_LIST:
            console.log("action.data = ", action.data);
            return state.merge({
                'mall_components_list': fromJS(action.data),
            })
        default:
            return state
    }
}

export default reducer
